import { useState } from "react";
import { t } from "@/i18n-js/instance";
import type { MarketingEmailTemplateContentType } from "@/react/types/MarketingEmailTemplates";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Sidebar } from "./Sidebar";
import { useNavigation } from "./Sidebar/useNavigation";
import { TemplateContents } from "./TemplateContents";
import type { ContentType } from "./TemplateContents/TemplateFilter";

const localeNamespace = "settings.emails.templates";

export const ListTemplatesV2 = ({
  onClose,
  onApply,
}: {
  onClose: () => void;
  onApply: (
    templateId: number,
    contentType: MarketingEmailTemplateContentType,
  ) => void;
}) => {
  const [contentType, setContentType] = useState<ContentType>("all");
  const { activeId, navigationItems, onClickNavItem } =
    useNavigation(setContentType);

  return (
    <>
      <div className="border-b-primary text-dark flex items-center justify-between border-b px-8 pb-5 pt-6">
        <Modal.Title size="sm">
          {t([localeNamespace, "template_library"])}
        </Modal.Title>
        <Modal.CloseButton onClick={onClose} />
      </div>
      <Modal.Body className="flex !px-0 pb-0 pt-6">
        <Sidebar
          activeId={activeId}
          navigationItems={navigationItems}
          onClickNavItem={onClickNavItem}
        />
        <TemplateContents
          selectedCategory={activeId}
          onApply={onApply}
          contentType={contentType}
          setContentType={setContentType}
        />
      </Modal.Body>
    </>
  );
};
